import { Injectable } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { AdminService, ApiService, AuthService, CalendarService, ConditionService, DialogService, FieldService, FormulaService, MetadataService, ModalService, SessionService, TranslatorService } from '..';
import { UscStoreService } from '../usc-store/usc-store.service';

@Injectable()
export class UscStoreSchedulingService {

    metaDataSub: Subscription;
    getConsultantSalesQuotaAchievementsSub: Subscription;
    getConsultantSalesGoalAchievementsSub: Subscription;
    getTodaysConsultantSalesGoalAchievementsSub: Subscription;
    getStoreSalesQuotaAchievementsSub: Subscription;
    getStoreTodaysSalesQuotaAchievementsSub: Subscription;
    getAwardedUsersSub: Subscription;
    p2w_achievement_initialized:boolean = false;
    init_mobile_session: boolean = false;

    public dialog_type_cancel_appt_confirmation: string = "dlg_svt_cancel_appt_confirmation";

    constructor(
        public metadataService: MetadataService,
        public sessionService: SessionService,
        public uscStoreService: UscStoreService,
        public apiService:ApiService
    ) { }

    getStoreSchedulerInfo(scheduler:string) {
        return this.apiService.processSchedulingActionOnGet(scheduler, "get_scheduler_info").map(
            (result) => { return result; }
        );
    }

    getAvailableTimeslots(scheduler:string, from:Date, to:Date): Observable<any> {
        var params = { from: from, to: to }
        return this.apiService.processSchedulingActionOnGet(scheduler, "get_time_slots", params).map(
            (result) => { return result; }
        );
    }

    bookSelectedTimeslot(scheduler:string, params:any) {
        return this.apiService.processSchedulingActionOnPost(scheduler, "book_time_slot", params, "raw").map(
            (result) => { return result; }
        );
    }

    getScheduledAppointmentByConfirmationNumber(scheduler:string, confirmation_number:string) {
        var params = { cn: confirmation_number }
        return this.apiService.processSchedulingActionOnGet(scheduler, "get_scheduled_appointment", params).map(
            (result) => { return result; }
        );
    }

    deleteScheduledAppointmentByConfirmationNumber(scheduler:string, confirmation_number:string) {
        var params = { cn: confirmation_number }
        return this.apiService.processSchedulingActionOnGet(scheduler, "delete_scheduled_appointment", params).map(
            (result) => { return result; }
        );
    }

    getAppointmentQueuePosition(scheduler:string, confirmation_number:string) {
        var params = { cn: confirmation_number }
        return this.apiService.processSchedulingActionOnGet(scheduler, "get_queue_item_position", params).map(
            (result) => { return result; }
        );
    }

    moveQueuePositionByOffset(scheduler:string, confirmation_number:string, offset:number)  {
        var params = { cn: confirmation_number, offset: offset }
        return this.apiService.processSchedulingActionOnGet(scheduler, "move_queue_position_by_offset", params).map(
            (result) => { return result; }
        );
    }

    removeFromSchedulingQueue(scheduler:string, confirmation_number:string) {
        var params = { cn: confirmation_number }
        return this.apiService.processSchedulingActionOnGet(scheduler, "remove_from_queue", params).map(
            (result) => { return result; }
        );
    }

    moveToInactiveQueue(scheduler:string, confirmation_number:string) {
        var params = { cn: confirmation_number }
        return this.apiService.processSchedulingActionOnGet(scheduler, "move_to_inactive_queue", params).map(
            (result) => { return result; }
        );
    }

    moveToActiveQueue(scheduler:string, confirmation_number:string) {
        var params = { cn: confirmation_number }
        return this.apiService.processSchedulingActionOnGet(scheduler, "move_to_active_queue", params).map(
            (result) => { return result; }
        );
    }

    initializeMobileSession() {
        if (!this.init_mobile_session) {
            this.init_mobile_session = true;
            this.uscStoreService.setPortalInitializationItem("loadMetadata", "initializing");
            // this.sessionService.log("Meta Data Loading:", new Date()); 
            this.metaDataSub = this.metadataService.loadMetadata().subscribe(
                data => { 
                    this.uscStoreService.setP2WInitializationItem("loadMetadata", "initialized");
                    this.sessionService.log("Meta Data Loaded", new Date());
                },
                err => { this.sessionService.log(err) }
            )

            if (!this.p2w_achievement_initialized && !this.uscStoreService.isP2WInitialized()) {
                this.initializeP2WAchievements();
            }
            
            this.uscStoreService.p2wReady.subscribe(ready => {
                if (ready) {
                    this.p2w_achievement_initialized = true;
                    this.uscStoreService.loadPreviousActionPlans();
                } 
            })
        }
    }
    
    initializeP2WAchievements(bReload: boolean = false) {
        this.uscStoreService.setP2WInitializationItem("getConsultantSalesQuotaAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getConsultantSalesGoalAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getTodaysConsultantSalesGoalAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getStoreSalesQuotaAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getStoreTodaysSalesQuotaAchievements", "initializing");
        this.uscStoreService.setP2WInitializationItem("getAwardedUsers", "initializing");

        this.getConsultantSalesQuotaAchievementsSub = this.uscStoreService.getConsultantSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getConsultantSalesQuotaAchievements", "initialized");
            this.sessionService.log('USC Mobile Consultant Sales Quota Achievements Loaded');
        })

        this.getConsultantSalesGoalAchievementsSub = this.uscStoreService.getConsultantSalesGoalAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getConsultantSalesGoalAchievements", "initialized");
            this.sessionService.log('USC Mobile Consultant Sales Goal Achievements Loaded');
        })

        this.getTodaysConsultantSalesGoalAchievementsSub = this.uscStoreService.getTodaysConsultantSalesGoalAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getTodaysConsultantSalesGoalAchievements", "initialized");
            this.sessionService.log("USC Mobile Today's Consultant Sales Goal Achievements Loaded");
        })

        this.getStoreSalesQuotaAchievementsSub = this.uscStoreService.getStoreSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getStoreSalesQuotaAchievements", "initialized");
            this.sessionService.log('USC Mobile Store Sales Quota Achievements Loaded');
        })

        this.getStoreTodaysSalesQuotaAchievementsSub = this.uscStoreService.getStoreTodaysSalesQuotaAchievements(bReload).subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getStoreTodaysSalesQuotaAchievements", "initialized");
            this.sessionService.log("USC Mobile Today's Store Sales Quota Achievements Loaded");
        })

        this.getAwardedUsersSub = this.uscStoreService.getAwardedUsers().subscribe(result => {
            this.uscStoreService.setP2WInitializationItem("getAwardedUsers", "initialized");
            this.sessionService.log("Awarded Users Loaded");
        }) 
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/usc-store-scheduling/usc-store-scheduling-service.ts